import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/dreamteam-lms/app/components/AuthDebugBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/dreamteam-lms/app/components/chrome/ChromeActiveGame.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/dreamteam-lms/app/components/chrome/ChromeAuthBridge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/dreamteam-lms/app/components/chrome/ChromeScripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/dreamteam-lms/app/components/GameNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GamingHubComponent"] */ "/app/apps/dreamteam-lms/app/components/GamingHubComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/dreamteam-lms/app/components/NativeAuthBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/dreamteam-lms/app/components/WaitingScreenSkip.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/dreamteam-lms/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/dreamteam-lms/app/providers/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompetitionProvider"] */ "/app/apps/dreamteam-lms/app/providers/CompetitionContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GamingHubProvider"] */ "/app/apps/dreamteam-lms/app/providers/GamingHubProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/app/apps/dreamteam-lms/app/providers/LanguageProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NativeProvider"] */ "/app/apps/dreamteam-lms/app/providers/NativeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/app/node_modules/.pnpm/@vercel+analytics@1.6.1_next@15.2.8_@babel+core@7.29.7_react-dom@19.0.1_react@19.0.1__react@19.0.1__react@19.0.1/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/app/node_modules/.pnpm/@vercel+speed-insights@1.3.1_next@15.2.8_@babel+core@7.29.7_react-dom@19.0.1_react@19.0.1__react@19.0.1__react@19.0.1/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.8_@babel+core@7.29.7_react-dom@19.0.1_react@19.0.1__react@19.0.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.8_@babel+core@7.29.7_react-dom@19.0.1_react@19.0.1__react@19.0.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer","Bounce"] */ "/app/node_modules/.pnpm/react-toastify@11.1.0_react-dom@19.0.1_react@19.0.1__react@19.0.1/node_modules/react-toastify/dist/unstyled.mjs");
